import * as React from "react";
export const EditIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={16} height={16} viewBox="0 0 46 46" {...props}>
      <path
        fill="#ffffff"
        d="M41.13 0C39.88 0 38.64 0.49 37.69 1.44L36.88 2.25L43.75 9.13C43.75 9.13 44.56 8.31 44.56 8.31C46.46 6.41 46.46 3.34 44.56 1.44C43.61 0.49 42.37 0 41.13 0ZM35.34 4.03C35.12 4.06 34.91 4.18 34.75 4.34L2.31 36.81C2.18 36.93 2.09 37.08 2.03 37.25L0.03 44.75C-0.06 45.09 0.04 45.46 0.29 45.71C0.54 45.96 0.91 46.06 1.25 45.97L8.75 43.97C8.92 43.91 9.07 43.82 9.19 43.69L41.66 11.25C42.05 10.86 42.06 10.23 41.67 9.83C41.29 9.43 40.65 9.43 40.25 9.81L7.97 42.09L3.91 38.03L36.19 5.75C36.49 5.46 36.58 5.01 36.41 4.63C36.24 4.25 35.86 4.01 35.44 4.03C35.41 4.03 35.38 4.03 35.34 4.03Z"
      />
    </svg>
  );
};
